import { parseMeetingTypesFromQueryParam } from '@helpers/parseMeetingTypesFromQueryParam';
import { serializeDateToQueryParam } from '@helpers/serializeDateToQueryParam';
import { TAppliedFilters } from 'app/types/TAppliedFilters';

export const buildJobsFiltersSearchParams = ({
  jobsFilter,
  statusFilter,
  asOneFilter,
  postFilter,
  meetingTypeFilter,
  durationFilter,
}: TAppliedFilters): Record<string, string | null> => {
  const activeMeetingTypes = asOneFilter ? parseMeetingTypesFromQueryParam((meetingTypeFilter ?? []).join(',')) : [];

  return {
    from: serializeDateToQueryParam(jobsFilter.from) || null,
    to: serializeDateToQueryParam(jobsFilter.to) || null,
    statuses: statusFilter.length ? statusFilter.join(',') : null,
    asOne: asOneFilter ? 'true' : null,
    post: postFilter && !asOneFilter ? 'true' : null,
    meetingTypes: activeMeetingTypes.length ? activeMeetingTypes.join(',') : null,
    durationFrom: durationFilter?.fromMinutes === undefined ? null : String(durationFilter.fromMinutes),
    durationTo: durationFilter?.toMinutes === undefined ? null : String(durationFilter.toMinutes),
  };
};
